// Design tokens — Direcionamentos. Ref: .md/DESIGN_UIUX.md

export const DIRECIONAMENTOS_COMPONENT_DESIGN = {
  root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',
  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
  topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
  topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
  sectionHeader: 'mt-[18px] first:mt-0 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3',
  sectionHeaderMain: 'min-w-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',
  stack: 'flex flex-col gap-3.5',
  cardFlush: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0',
  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca]',
  link: 'text-[13px] font-semibold text-[#6d28d9] transition-colors hover:text-[#5b21b6] hover:underline',
  label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
  input:
    'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] text-[#18181b] shadow-none placeholder:text-[#a1a1aa] focus:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd]',
  badge: 'inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-md text-[12px] font-semibold whitespace-nowrap border bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
  tableWrap: 'w-full overflow-x-auto min-w-0',
  tableHeadRow: 'flex items-center px-[26px] py-3 border-b border-[#f0f0f3] bg-[#fafafb]',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa]',
  tableRow: 'group flex items-center px-[26px] py-3.5 border-b border-[#f0f0f3] last:border-b-0 hover:bg-[#fafafb]',
  tableCell: 'text-[14px] text-[#18181b]',
  tableCellMuted: 'text-[13px] text-[#71717a]',
  emptyWrap: 'px-2 py-10 text-center',
  emptyIcon: 'mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',
  dialogTitle: 'text-[15px] font-semibold text-[#18181b]',
  page: {
    container: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b]',
    header: {
      container: 'flex flex-col md:flex-row md:items-start gap-4',
      title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
      subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
    },
    actionButton:
      'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold shadow-[0_2px_8px_rgba(124,58,237,.32)] hover:from-[#7c3aed] hover:to-[#6d28d9]',
  },
  emptyState: {
    container: 'px-2 py-10 text-center',
    iconBox: 'mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
    title: 'text-[15px] font-semibold text-[#18181b]',
    description: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',
    button: 'text-[13px] font-semibold text-[#6d28d9] hover:text-[#5b21b6] hover:underline',
  },
  dialog: {
    paper: {
      borderRadius: '12px',
      padding: '26px',
      boxShadow: 'none',
    },
    container: 'px-[26px] pb-2',
    header: {
      sx: { p: 0, pb: 1, fontSize: '15px', fontWeight: 600, color: '#18181b' },
    },
    content: {
      wrapper: 'flex flex-col gap-5',
      section: {
        label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
      },
    },
    actions: {
      cancelButton:
        'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] hover:bg-[#f4f4f7]',
      confirmButton: {
        base: 'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] text-white text-[14px] font-semibold',
        active: 'bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] shadow-[0_2px_8px_rgba(124,58,237,.32)] hover:from-[#7c3aed] hover:to-[#6d28d9]',
        disabled: 'bg-[#e4e4e7] text-[#a1a1aa]',
      },
    },
  },
};

export default DIRECIONAMENTOS_COMPONENT_DESIGN;
